import { useMemo } from 'react';
import { SimpleShell } from '../shell/SimpleShell';
import { termsHtml } from '../terms';

/** The Terms of Use and Privacy Notice, to read again after accepting them. */
export function LegalPage() {
  const html = useMemo(termsHtml, []);
  return (
    <SimpleShell>
      <div className="sx-form">
        <div>
          <a className="sx-back" href="#/account">← Back to your account</a>
          <h1 className="sx-h1">Terms and privacy</h1>
        </div>
        <div className="sx-prose sx-legal" style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </SimpleShell>
  );
}
